import * as React from 'react';

import type { IconProps } from './types';

export const TextUnderline = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M9.67947 12.929C9.02117 12.929 8.45306 12.8388 7.97512 12.6584C7.49718 12.4691 7.1004 12.2121 6.78478 11.8874C6.47817 11.5538 6.24822 11.1615 6.09492 10.7106C5.95063 10.2507 5.87849 9.74571 5.87849 9.19562V4.63379H7.98864V9.01978C7.98864 9.39852 8.02922 9.72316 8.11038 9.99369C8.20056 10.2552 8.31779 10.4716 8.46207 10.643C8.61538 10.8053 8.79573 10.9225 9.00314 10.9947C9.21956 11.0668 9.45403 11.1029 9.70652 11.1029C10.2205 11.1029 10.6353 10.9451 10.951 10.6294C11.2756 10.3138 11.4379 9.77727 11.4379 9.01978V4.63379H13.5481V9.19562C13.5481 9.74571 13.4714 10.2507 13.3181 10.7106C13.1648 11.1705 12.9304 11.5673 12.6147 11.9009C12.2991 12.2256 11.8978 12.4781 11.4109 12.6584C10.9239 12.8388 10.3468 12.929 9.67947 12.929Z"
        fill={color}
      />
      <path d="M4.93164 13.5106H14.4949V15.1338H4.93164V13.5106Z" fill={color} />
    </svg>
  )
);

export default TextUnderline;
